import React from 'react';

/*
 *  @Description:   Stateless component that renders a Download Manager Icons.
 */

export const DownloadManagerIcon = (props) => {

  return (<g id="path">
      <polyline points="8 17 12 21 16 17"/>
      <line x1="12" y1="12" x2="12" y2="21"/>
      <path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"/>
    </g>
  )

};

export const StopDownloadIcon = (props) => {

  return (<g id="path">
      <circle cx="12" cy="12" r="10"/>
      <rect x="9" y="9" width="6" height="6"/>
    </g>
  )

};

export const StartDownloadIcon = (props) => {

  return (<g id="path">
      <circle cx="12" cy="12" r="10"/>
      <polygon points="10 8 16 12 10 16 10 8"/>
    </g>
  )

};

export const DeleteDownloadIcon = (props) => {

  return (<g id="path">
      <circle cx="12" cy="12" r="10"/>
      <line x1="15" y1="9" x2="9" y2="15"/>
      <line x1="9" y1="9" x2="15" y2="15"/>
    </g>
  )

};

export const PauseDownloadIcon = (props) => {

  return (<g id="path">
      <circle cx="12" cy="12" r="10"/>
      <line x1="10" y1="15" x2="10" y2="9"/>
      <line x1="14" y1="15" x2="14" y2="9"/>
    </g>
  )

};

export const UpDownloadIcon = () => {
  return (
    <g id="path">
      <circle cx="12" cy="12" r="10"/>
      <polyline points="8 14 12 10 16 14"/>
    </g>
  )
};

export const DownDownloadIcon = () => {
  return (
    <g id="path">
      <circle cx="12" cy="12" r="10"/>
      <polyline points="8 11 12 15 16 11"/>
    </g>
  )
};